(function () {
  let timerIntervalId;

  const pad = (n) => String(n < 10 ? '0' + n : n);

  const hasCountdowns = () => Boolean(document.querySelector('.js-countdown'));

  const initTimer = () => {
    document.querySelectorAll('.js-countdown').forEach(function (el) {
      const mockTimer = el.dataset.mockTimer === 'true' || el.dataset.mockTimer === true;
      const completedCountdown = el.dataset.completed;
      const countdown = el.querySelector('.countdown__main');
      const countdownHeading = el.querySelector('.countdown__end-info');
      const daysEl = el.querySelector('.countdown_block_days');
      const hoursEl = el.querySelector('.countdown_block_hours');
      const minutesEl = el.querySelector('.countdown_block_minutes');
      const secondsEl = el.querySelector('.countdown_block_seconds');
      const section = el.closest('.shopify-section');

      let userDate, userTime;

      if (mockTimer) {
        const d = new Date();
        d.setDate(d.getDate() + 3);
        const year = d.getFullYear();
        const month = pad(d.getMonth() + 1);
        const day = pad(d.getDate());
        let h = d.getHours() - 1;
        if (h >= 24) { h -= 24; d.setDate(d.getDate() + 1); }
        userDate = `${year}-${month}-${day}`;
        userTime = `${pad(h)}:${pad(d.getMinutes())}`;
      } else {
        userDate = el.dataset.date;
        userTime = el.dataset.time;
      }

      const countdownDate = new Date(`${userDate}T${userTime}`);
      const now = new Date();
      const distance = countdownDate.getTime() - now.getTime();
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0 && completedCountdown === 'hide_section') {
        if (section) section.style.display = 'none';
      } else if (distance < 0 && completedCountdown === 'show_text') {
        if (countdown) countdown.style.display = 'none';
        if (countdownHeading) countdownHeading.style.display = '';
      } else {
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }
    });
  };

  const stopTimer = () => {
    if (!timerIntervalId) return;
    clearInterval(timerIntervalId);
    timerIntervalId = null;
  };

  const syncTimerState = () => {
    if (document.hidden || !hasCountdowns()) {
      stopTimer();
      return;
    }

    initTimer();

    if (timerIntervalId) return;
    timerIntervalId = setInterval(initTimer, 1000);
  };

  document.addEventListener('visibilitychange', syncTimerState);
  document.addEventListener('shopify:section:load', syncTimerState);
  document.addEventListener('shopify:section:reorder', syncTimerState);
  document.addEventListener('shopify:section:unload', syncTimerState);
  syncTimerState();
})();
